import { ShareSettings } from "../models/share-settings";

export class UpdateShareSettingsRequest{
    planogramId: string = '';
    collaborationEnabled: boolean
    feedbackDeadline?: string
    constructor(planogramId: string, settings: ShareSettings){
        this.planogramId = planogramId;
        this.collaborationEnabled = settings.collaborationEnabled;
        if(settings.feedbackDeadline)
            this.feedbackDeadline = settings.feedbackDeadline;
    }
}